import getCurrentMainDomain from './getCurrentMainDomain'
import getSubdomain from './getSubdomain'

const reservedSubdomains = [
  '',
  'accelerator',
  'account',
  'accounts',
  'admin',
  'atoms',
  'auth',
  'bank-transfers',
  'boleta',
  'buckets',
  'chat',
  'coinsadmin',
  'commander',
  'components',
  'content',
  'crisp',
  'crisp2',
  'cuenta',
  'data',
  'delivery',
  'delivery-admin',
  'developers',
  'entregas',
  'experiments',
  'finanzas',
  'help',
  'hub',
  'intra',
  'jobs',
  'logistics',
  'mipos',
  'onboarding',
  'people',
  'pide',
  'pos',
  'reservaspos',
  'sales',
  'sign',
  'support',
  'tabs',
  'tofu-product',
  'tracking',
  'unete',
  'vite',
  'web',
  'webadmin',
  'websiteadminframe',
  'www'
]

function getHostnameSubdomain() {
  if (getCurrentMainDomain()) return getSubdomain()
  return String(window.location.hostname).split('.')[0]
}

export function getReservedJustoSubdomain() {
  const subdomain = getHostnameSubdomain()
  const [firstLabel] = subdomain.split('.')

  if (
    reservedSubdomains.includes(subdomain) ||
    reservedSubdomains.includes(firstLabel) ||
    subdomain.endsWith('.service')
  ) {
    return firstLabel
  }

  return null
}

export default function isReservedJustoSubdomain() {
  return !!getReservedJustoSubdomain()
}
